// App nativo do signatário (spec 058).

/** Aviso a quem não é signatário e tenta entrar no app, pelo login ou por sessão restaurada. */
export const NATIVE_APP_SIGNER_ONLY_MESSAGE = 'Acesso permitido apenas para usuários assinantes no aplicativo móvel'

/** Áreas autenticadas que o app exibe; qualquer outra rota leva às assinaturas. */
export const NATIVE_APP_ALLOWED_PREFIXES = ['/signer', '/account']

export const NATIVE_APP_HOME = '/signer/board'
